module.exports = __webpack_public_path__ + "static/media/health-service-executive.bce5708a.png";